import { GridCell } from '@progress/kendo-react-grid'
import React from 'react'

export class PartnerCode extends GridCell {
  public render() {
    return <td>
      {this.props.dataItem.community_partner_code ? <p>{this.props.dataItem.community_partner_code}</p> : null }
    </td>
  }
}



// WEBPACK FOOTER //
// ./src/pages/lead-text/grid-cells/partner-code-cell.tsx